import { render, staticRenderFns } from "./VehicleForm.vue?vue&type=template&id=55a332ce&scoped=true&"
import script from "./VehicleForm.vue?vue&type=script&lang=js&"
export * from "./VehicleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a332ce",
  null
  
)

export default component.exports